
/**
 * @event domaine:swell-api-ready
 * @description Dispatched when the Swell API is fully initialized and customer details are available.
 * @detail {Object} customerDetails - The customer details object returned by Swell API.
 * @example
 * document.addEventListener('domaine:swell-api-ready', (event) => {
 *   const customerDetails = event.detail.customerDetails;
 *   // Use customerDetails here
 * });
 */
class DomaineYotpoLoyalty extends HHBaseElement {
  constructor() {
    super();
    this.interval = null;
    this._apiReady = false;
    this._customerDetails = null;
    this._readyCallbacks = [];
    this.setup = this.setup.bind(this);
    this.checkLoyaltyStatus = this.checkLoyaltyStatus.bind(this);
    this._dispatchReadyEvent = this._dispatchReadyEvent.bind(this);
  }

  get isLoggedIn() {
    return this.getAttribute('logged-in') === 'true';
  }

  connectedCallback() {
    if (!this.isLoggedIn) return;
    this.setup();
  }

  setup() {
    if (!window?.swellAPI || typeof window?.swellAPI?.getCustomerDetails()?.isMember === 'undefined') {
      this.interval = setInterval(this.checkLoyaltyStatus, 500);
    } else {
      this._onApiReady();
    }
  }

  checkLoyaltyStatus() {
    if (window?.swellAPI?.getCustomerDetails()?.isMember !== undefined) {
      clearInterval(this.interval);
      this._onApiReady();
    }
  }

  _onApiReady() {
    this._apiReady = true;
    this._customerDetails = window.swellAPI.getCustomerDetails();
    this._dispatchReadyEvent();
    this._readyCallbacks.forEach((cb) => cb(this._customerDetails));
    this._readyCallbacks = [];
  }

  _dispatchReadyEvent() {
    this.dispatchEvent(
      new CustomEvent('domaine:swell-api-ready', {
        detail: { customerDetails: this._customerDetails },
        bubbles: true,
        composed: true,
      })
    );
  }

  get customerDetails() {
    if (this._apiReady) {
      return this._customerDetails;
    } else {
      return null;
    }
  }

  get pointsBalance() {
    return this._apiReady ? this._customerDetails?.pointsBalance : null;
  }

  get isMember() {
    return this._apiReady ? this._customerDetails?.isMember : null;
  }

  /**
   * Registers a callback to be executed when the API is ready.
   * If the API is already ready, the callback is invoked immediately with the customer details.
   * Otherwise, the callback is queued and will be called once the API becomes ready.
   *
   * @public
   * @param {function(Object): void} callback - Function to execute when the API is ready. Receives customer details as an argument.
   *
   * @example
   * component.onApiReady((customerDetails) => {
   *   // Use customerDetails after API is ready
   * });
   */
  onApiReady(callback) {
    if (this._apiReady) {
      callback(this._customerDetails);
    } else {
      this._readyCallbacks.push(callback);
    }
  }
}

window.customElements.define('domaine-yotpo-loyalty', DomaineYotpoLoyalty);
